import React from "react";
import PropTypes from "prop-types";
import { Chatter } from "resourceModels";
import KeyValuePairs from "components/Common/KeyValuePairs";
import "./style.scss";

class ConversationsChatterModal extends React.Component {
  getStorageValues() {
    return this.props.chatter.storage.merge({
      email: this.props.chatter.email
    });
  }

  render() {
    return (
      <div className="ConversationsChatterModal Modal__modal">
        <h5 className="Modal__title">
          Chatter Info
        </h5>
        <div className="Modal__content">
          <KeyValuePairs object={this.getStorageValues().toJS()} />
        </div>
      </div>
    );
  }
}

ConversationsChatterModal.propTypes = {
  chatter: PropTypes.instanceOf(Chatter).isRequired
};

export default ConversationsChatterModal;
